import BTHttp from '@/core/common/request'

export function getBannerList (obj) {
    return BTHttp({
        url: `/banner/wx/list`,
        method: 'post',
        data: obj
    })
}

export function getAdvertPage (obj) {
    return BTHttp({
        url: `/advert/wx/page`,
        method: 'post',
        data: obj
    })
}

export function getAdvertInfo (id) {
    return BTHttp({
        url: `/advert/wx/info/` + id,
        method: 'get'
    })
}

